import React, { useContext, useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import axios from "axios";
import { Link } from "react-router-dom";
import Container from "@mui/material/Container";
import Layout from "./Layout";
import FloorVisualizer from "./FloorVisualizer";
import Grid from "@mui/material/Grid";
import { AppContext } from "../utilities/context";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";

const LocationsPosition = () => {
  const intl = useIntl();
  const context = useContext(AppContext);
  const [autoRefresh, setAutoRefresh] = useState(false);
  const [floors, setFloors] = useState([]);
  const [selectedFloorId, setSelectedFloorId] = useState(
    context?.user?.shopId || ""
  );
  const [loadingFloors, setLoadingFloors] = useState(false);

  useEffect(() => {
    if (context) {
      context.updateBreadcrumbsState([
        {
          label: intl.formatMessage({ id: "app.header.home.label" }),
          url: "/",
        },
        {
          label: intl.formatMessage({ id: "app.header.floors.label" }),
        },
      ]);
    }
  }, []);

  useEffect(() => {
    fetchFloors();
  }, []);

  async function fetchFloors() {
    setLoadingFloors(true);
    try {
      const res = await axios.get("/api/floors");
      const payload = res.data || {};
      const list = Array.isArray(payload) ? payload : payload.floors || [];
      setFloors(list);
      if (!selectedFloorId && list && list.length > 0) {
        const id = list[0].id || list[0]._id || list[0].floorId;
        setSelectedFloorId(id);
      }
    } catch (err) {
      console.error("Error fetching floors:", err);
    } finally {
      setLoadingFloors(false);
    }
  }

  async function handleFloorChange(event) {
    const id = event.target.value;
    setSelectedFloorId(id);
    try {
      await axios.get(`/api/floors/${id}`);
    } catch (err) {
      console.error(`Error fetching floor ${id}:`, err);
    }
  }

  return (
    <Layout>
      <Container maxWidth={false} disableGutters>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={autoRefresh}
                  onChange={(_, checked) => setAutoRefresh(checked)}
                  color="primary"
                />
              }
              label="Auto Refresh"
              sx={{ mb: 2 }}
            />

            <Box sx={{ display: "flex", alignItems: "center", mb: 2, gap: 2 }}>
              <FormControl variant="outlined" size="small" sx={{ minWidth: 240 }}>
                <InputLabel id="floor-select-label">Floor</InputLabel>
                <Select
                  labelId="floor-select-label"
                  id="floor-select"
                  value={selectedFloorId}
                  label="Floor"
                  onChange={handleFloorChange}
                >
                  {floors.map((f) => (
                    <MenuItem key={f.id || f._id || f.floorId} value={f.id || f._id || f.floorId}>
                      {f.name || f.label || (f.floor && f.floor.name) || `Floor ${f.id || f._id}`}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {loadingFloors && <CircularProgress size={20} />}
            </Box>

            <FloorVisualizer floorId={selectedFloorId || context?.user?.shopId} autoRefresh={autoRefresh} />
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default LocationsPosition;
